import { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import "./style.scss";
import ThanksFor from "../ThanksFor";
import RectButton from "../../components/ui/button/RectButton";
import HIc from "../../components/assets/icons/h-ic.svg";

import * as robotArmDataD from '../../components/assets/json/lottie/you-are-now-desktop.json'
import * as robotArmDataM from '../../components/assets/json/lottie/you-are-now-mobile.json'

class ThanksForSubscribing extends Component {
    render() {
        return (
            <>
                <ThanksFor className="ths-for-subscribing" robotArmDataD={robotArmDataD} robotArmDataM={robotArmDataM}>
                    <div className="h-image"><img src={HIc} alt="Handwrytten" /></div>
                    <h1 style={{visibility:'hidden'}}><span>Congrats!</span><span>You are now a Gold Member.</span></h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <Link className="action-bt" to="/"><RectButton text="Send a Card" /></Link>
                </ThanksFor>
            </>
        )
    }
}

export default withRouter(ThanksForSubscribing);